import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      beginningTime: '',
      endTime: '',
      loading: false,
    };
  },

  mutations: {
    update(state, { key, value }) {
      state[key] = value;
    },
  },

  getters: {
    beginningTime: (state) => state.beginningTime,
    endTime: (state) => state.endTime,
    loading: (state) => state.loading,
  },

  actions: {
    updateWorkingHours({ commit, dispatch }, { userId, beginningTime, endTime }) {
      commit('update', { key: 'loading', value: true });

      const workHoursData = {};
      if (beginningTime) workHoursData.beginning_time = beginningTime;
      if (endTime) workHoursData.end_time = endTime;

      const response = Network.patch(`/users/${userId}/update_work_hours`, {
        work_hours: workHoursData,
      }, {
        success: (data) => {
          commit('update', { key: 'beginningTime', value: data.beginning_of_workday || beginningTime });
          commit('update', { key: 'endTime', value: data.end_of_workday || endTime });
          dispatch('setSuccessToast', 'Successfully updated working hours', { root: true });
        },
        error: (error) => {
          dispatch('setErrorToast', 'Failed to update working hours', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });

      return response;
    },
  },
};
